module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-testimonials"
  }, [_c('div', {
    staticClass: "slider-testimonials__container"
  }, [_c('div', {
    staticClass: "slider-testimonials__title"
  }, [_c('object', {
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.props.icon,
      "aria-label": "testimonials"
    }
  })]), _c('div', {
    staticClass: "slider-testimonials__slider"
  }, [_c('div', {
    staticClass: "slider-testimonials__slides"
  }, [_c('Carousel', {
    ref: "testimonial-carousel",
    attrs: {
      "autoplay": false,
      "perPage": 1,
      "loop": true,
      "paginationEnabled": false
    }
  }, _vm._l((_vm.props.testimonials), function(testimonial, i) {
    return _c('Slide', {
      key: i,
      staticClass: "slider-testimonials__slide"
    }, [_c('div', {
      staticClass: "slider-testimonials__slide-body"
    }, [_c('div', {
      staticClass: "slider-testimonials__quotes"
    }, [_c('Icon', {
      attrs: {
        "name": "quotes"
      }
    })], 1), _c('div', {
      staticClass: "slider-testimonials__body"
    }, [_c('div', {
      staticClass: "slider-testimonials__testimonial",
      domProps: {
        "innerHTML": _vm._s(testimonial.text)
      }
    }), _c('div', {
      staticClass: "slider-testimonials__author",
      domProps: {
        "innerHTML": _vm._s(testimonial.author)
      }
    })]), _c('div', {
      staticClass: "slider-testimonials__image",
      style: ({
        backgroundImage: 'url(' + testimonial.image + ')'
      })
    })])])
  }), 1), _c('div', {
    staticClass: "slider-testimonials__arrow slider-testimonials__arrow--prev",
    on: {
      "click": function($event) {
        _vm.SlideCarousel('prev')
      }
    }
  }, [_vm._v("< prev       ")]), _c('div', {
    staticClass: "slider-testimonials__arrow slider-testimonials__arrow--next",
    on: {
      "click": function($event) {
        _vm.SlideCarousel('next')
      }
    }
  }, [_vm._v("next >       ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558516c0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-testimonials/slider-testimonials.pug
// module id = 577
// module chunks = 1